import React from "react";
import { Link, useLocation } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";

const tabs = [
  {
    id: "enquiryReport",
    title: "Enquiry Reports",
    icon: "ri-bar-chart-line",
    path: "/enquiry/reports",
    activePaths: ["/enquiry/reports"],
  },
  {
    id: "enquiries",
    title: "Enquiries",
    icon: "ri-bar-chart-line",
    path: "/enquiry",
    activePaths: [
      "/enquiry",
      "/enquiry/update",
      "/enquiry/add",
      "/enquiry/detail",
    ],
  },
  {
    id: "followUps",
    title: "Follow-ups",
    icon: "ri-user-add-line",
    path: "/enquiry/followups",
    activePaths: ["/enquiry/followups"],
  },
  {
    id: "enquiryForm",
    title: "Enquiry Form",
    icon: "ri-layout-grid-line",
    path: "/enquiry/form/print",
    activePaths: ["/enquiry/form/print"],
  },
  {
    id: "enquiryForm",
    title: "Demo Form",
    icon: "ri-codepen-line",
    path: "/enquiry/demo/form/print",
    activePaths: ["/enquiry/demo/form/print"],
  },
];

export default function Mater({ children }) {
  return;
  const hasAccess = usePrivateLink();

  const visibleTabs = tabs.filter((tab) => hasAccess(tab.path));

  return (
    <>
      <ModuleHeader tabs={visibleTabs} />
      {children}
    </>
  );
}

// export default function Master() {
//   const { pathname } = useLocation();
//   const hasAccess = usePrivateLink();

//   return (
//     <div className="col-12 mb-2">
//       <div
//         className="d-flex flex-wrap gap-2 p-2 ms-auto"
//         style={{
//           overflowX: "auto",
//         }}
//       >
//         {hasAccess("/enquiry/reports") && (
//           <Link
//             to="/enquiry/reports"
//             className={`btn d-flex align-items-center ${
//               pathname === "/enquiry/reports"
//                 ? "btn-primary"
//                 : "btn-outline-primary"
//             }`}
//           >
//             <i className="ri-bar-chart-line me-2 ri-20px"></i>
//             Enquiry Reports
//           </Link>
//         )}

//         {hasAccess("/enquiry") && (
//           <Link
//             to="/enquiry"
//             className={`btn d-flex align-items-center ${
//               [
//                 "/enquiry",
//                 "/enquiry/update",
//                 "/enquiry/add",
//                 "/enquiry/detail",
//               ].includes(pathname)
//                 ? "btn-primary"
//                 : "btn-outline-primary"
//             }`}
//           >
//             <i className="ri-book-line me-2 ri-20px"></i>
//             Enquiries
//           </Link>
//         )}

//         {hasAccess("/enquiry/followups") && (
//           <Link
//             to="/enquiry/followups"
//             className={`btn d-flex align-items-center ${
//               pathname === "/enquiry/followups"
//                 ? "btn-primary"
//                 : "btn-outline-primary"
//             }`}
//           >
//             <i className="ri-user-add-line me-2 ri-20px"></i>
//             Followups
//           </Link>
//         )}

//         {hasAccess("/enquiry/form") && (
//           <Link
//             to="/enquiry/form/print"
//             className={`btn d-flex align-items-center ${
//               pathname === "/enquiry/form/print"
//                 ? "btn-primary"
//                 : "btn-outline-primary"
//             }`}
//           >
//             <i className="ri-layout-grid-line me-2 ri-20px"></i>
//             Enquiry Form
//           </Link>
//         )}

//         {hasAccess("/enquiry/demo/form") && (
//           <Link
//             to="/enquiry/demo/form/print"
//             className={`btn d-flex align-items-center ${
//               pathname === "/enquiry/demo/form/print"
//                 ? "btn-primary"
//                 : "btn-outline-primary"
//             }`}
//           >
//             <i className="ri-codepen-line me-2 ri-20px"></i>
//             Demo Form
//           </Link>
//         )}
//       </div>
//     </div>
//   );
// }
